import clsx from 'clsx';
import * as style from './Success.css';

interface ISuccessProps {
  isBanner?: boolean;
}

export const Success: React.FC<ISuccessProps> = ({ isBanner = false }) => {
  return (
    <div className={clsx(style['container'], isBanner && style['banner'])}>
      <div className={style['title']}>
        Спасибо! <br /> Мы свяжемся с Вами в ближайшее время
      </div>
    </div>
  );
};
